import { Link } from "react-router-dom";
import { Seo, localBusinessLD } from "../lib/seo";
import { CITIES } from "../data/cities";
import { Reveal, SectionHead } from "../components/Reveal";
import { PageHero, CtaBand } from "../components/Shared";

export default function ZonesPage() {
    return (
        <>
            <Seo
                title="Zones d'intervention — Peintre & sols dans le Vexin, l'Oise et le Val-d'Oise | Solino Pro"
                description="Solino Pro intervient dans un rayon de 40 km autour de Chaumont-en-Vexin : Gisors, Méru, Marines, Magny-en-Vexin, Chars, Beauvais, Pontoise. Devis gratuit sous 48 h."
                path="/zones"
                jsonld={localBusinessLD()}
            />
            <PageHero
                img={CITIES[0].hero}
                crumb="Solino Pro — Zone 40 km"
                title="Du Vexin à Beauvais,"
                serif="vos voisins."
            />
            <section className="mx-auto max-w-[1400px] px-5 sm:px-8 py-20 lg:py-28" data-testid="zones-grid">
                <SectionHead
                    eyebrow="8 villes, 1 artisan"
                    title="Chaque ville a sa page —"
                    serif="et son artisan dédié."
                    text="Nous avons volontairement limité notre zone à un rayon de 40 km autour de Chaumont-en-Vexin : c'est ce qui permet des visites rapides, des devis fiables et un vrai suivi de chantier."
                />
                <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
                    {CITIES.map((c, i) => (
                        <Reveal key={c.slug} delay={i * 0.05}>
                            <Link
                                to={`/peintre-${c.slug}`}
                                className="group relative block overflow-hidden border border-linew aspect-[4/3] bg-coal"
                                data-testid={`zones-card-${c.slug}`}
                            >
                                <img
                                    src={c.hero}
                                    alt={`Intervention à ${c.name}`}
                                    loading="lazy"
                                    className="absolute inset-0 w-full h-full object-cover opacity-45 group-hover:opacity-70 group-hover:scale-105 transition-all duration-700"
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/30 to-transparent" />
                                <div className="relative h-full flex flex-col justify-end p-6">
                                    <span className="text-[10px] uppercase tracking-[0.25em] text-gold font-semibold">
                                        {c.km === 0 ? "Notre base" : `${c.km} km`} · {c.cp}
                                    </span>
                                    <span className="mt-1 text-2xl font-light text-ivory group-hover:text-gold transition-colors">{c.name}</span>
                                </div>
                            </Link>
                        </Reveal>
                    ))}
                </div>
            </section>
            <CtaBand />
        </>
    );
}
